/**
 * Mechanical Equipment Tool - Equipment Placement
 * 
 * Places mechanical equipment (AHUs, VAVs, etc.).
 */

import { v4 as uuidv4 } from 'uuid';
import { Element } from '../core/types';
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';
import * as THREE from 'three';

export interface EquipmentGeometryData {
    position: [number, number, number];
    rotation: number;
}

export interface EquipmentElement extends Element {
    category: 'Mechanical Equipment';
    geometryData: EquipmentGeometryData;
}

export class EquipmentTool extends BaseTool {
    id = 'equipment';
    name = 'Mechanical Equipment';
    cursor = 'crosshair';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        const point = this.getIntersection(event);
        if (!point) return;

        const snapped = this.snapToGrid(point);
        this.createEquipment(snapped);
    }

    onPointerMove(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        const point = this.getIntersection(event);
        if (point) {
            const snapped = this.snapToGrid(point);
            this.context.appStore.setToolPreview({
                type: 'equipment',
                position: snapped
            });
        }
    }

    onPointerUp(_event: ThreeEvent<PointerEvent>): void { }

    private createEquipment(point: THREE.Vector3) {
        if (!this.context) return;

        const geometryData: EquipmentGeometryData = {
            position: [point.x, point.y, point.z],
            rotation: 0
        };

        const equipment: EquipmentElement = {
            id: uuidv4(),
            category: 'Mechanical Equipment',
            type: 'AHU: Vertical',
            parameters: {
                'Air Flow': '2000 L/s',
                'Cooling Capacity': '50 kW'
            },
            constraints: [],
            geometryData
        };

        this.context.bimStore.addElement(equipment);
    }
}
